import { FC } from "react";

import { usePageContext } from "@ryde/redux";

import { DirectionCell } from "../../grid";
import { IRenderColumnTemplate } from "./_core";
import { isMealOnlyShiftRow } from "./direction-cell.utils";

export const DirectionCellTemplate: FC<IRenderColumnTemplate> = ({
  value,
  rowOriginal,
}) => {
  const { entity } = usePageContext();
  // RYDE-8171: only the shifts grid marks meal-only rows; every other grid keeps its plain direction pill.
  const isMealOnly = entity === "shift" && isMealOnlyShiftRow(rowOriginal);

  return <DirectionCell value={value} isMealOnly={isMealOnly} />;
};
